import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FiltroVwAplicacoesLavoura } from '../classes/FiltroVwAplicacoesLavoura';
@Injectable({
  providedIn: 'root'
})
export class VwAplicacoesLavouraService {

  constructor(private http: HttpClient) { }

  get(filtro: FiltroVwAplicacoesLavoura): Observable<any>{
    return this.http.post(`${environment.apiURL}/VwAplicacoesLavoura`, filtro);
  }
  exportar(filtro: FiltroVwAplicacoesLavoura): Observable<any>{
    return this.http.post(`${environment.apiURL}/VwAplicacoesLavoura/Exportar`, filtro);
  }
}
